import { useUserSettings } from '../../utils/use-user-settings';
import {
  CommandDashboardTileDefinition,
  describeRequiredPermissions,
  isTilePermitted,
} from './tile-config';

/** Whether the current user still has permission for a tile already on their dashboard. */
export function useCanSeeTile(tile: CommandDashboardTileDefinition): boolean {
  const userSettings = useUserSettings();
  return isTilePermitted(tile, userSettings);
}

/**
 * Disabled-action tooltip when a placed tile's permission has been revoked.
 * Used for Refresh and View All Activities (and the body's click-through).
 */
export function tileRefreshDisabledReason(
  tile: CommandDashboardTileDefinition,
  hasPermission: boolean
): string | undefined {
  return hasPermission
    ? undefined
    : `You need "${describeRequiredPermissions(
        tile
      )}" access to perform this action`;
}

export function useTileAccess(tile: CommandDashboardTileDefinition) {
  const hasPermission = useCanSeeTile(tile);
  return {
    hasPermission,
    refreshDisabledReason: tileRefreshDisabledReason(tile, hasPermission),
  };
}
